exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-items-block-m-dic[data-v-4abd430e]{width:100%!important;color:#929292;font-size:14px;text-align:left}.mr-10[data-v-4abd430e]{margin-right:10px}.cloud-modal-items-block div[data-v-4abd430e]:first-child{width:30%}.cloud-modal-items-block div[data-v-4abd430e]:nth-child(2){width:70%}.cloud-modal-add-block[data-v-4abd430e]{border:none;margin-bottom:35px}.header-items-block-m[data-v-4abd430e]{margin:7px 0 10px}", ""]);

// exports
